import { render, staticRenderFns } from "./miniTweets.vue?vue&type=template&id=47080322&"
import script from "./miniTweets.vue?vue&type=script&lang=js&"
export * from "./miniTweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports